export const setData = (data) => {
    if (!data) return { items: [], isLoaded: false };
    return { items: data, isLoaded: true };
};

export const setDataWithErrorMessage = (errorMessage) => {
    return { items: [], isLoaded: true, errors: [errorMessage] };
};
